// Array of regex patterns for different license plate formats
const regexPatterns = [
  /^[A-Z]{2}\d{2}\d{2}$/, // XX-99-99
  /^\d{2}\d{2}[A-Z]{2}$/, // 99-99-XX
  /^\d{2}[A-Z]{2}\d{2}$/, // 99-XX-99
  /^[A-Z]{2}\d{2}[A-Z]{2}$/, // XX-99-XX
  /^[A-Z]{2}[A-Z]{2}\d{2}$/, // XX-XX-99
  /^\d{2}[A-Z]{2}[A-Z]{2}$/, // 99-XX-XX
  /^\d{2}[A-Z]{3}\d{1}$/, // 99-XXX-9
  /^\d{1}[A-Z]{3}\d{2}$/, // 9-XXX-99
  /^[A-Z]{2}\d{3}[A-Z]{1}$/, // XX-999-X
  /^[A-Z]{1}\d{3}[A-Z]{2}$/, // X-999-XX
  /^[A-Z]{3}\d{2}[A-Z]{1}$/, // XXX-99-X
  /^[A-Z]{1}\d{2}[A-Z]{3}$/, // X-99-XXX
  /^\d{1}[A-Z]{2}\d{3}$/, // 9-XX-999
  /^\d{3}[A-Z]{2}\d{1}$/, // 999-XX-9
  /^CD[ABFJNST]\d{1,3}$/, // Diplomatic license plate, e.g.: CDB1 or CDJ45
];

// Function to determine license plate format
const determineLicensePlateFormat = (licensePlate: string): number => {
  const cleanedPlate = licensePlate.replace(/-/g, "").toUpperCase();
  return regexPatterns.findIndex((pattern) => pattern.test(cleanedPlate));
};

// Function to format license plate
export const formatLicensePlate = (licensePlate: string): string => {
  const cleanedPlate = licensePlate.replace(/-/g, "").toUpperCase();
  const formatId = determineLicensePlateFormat(cleanedPlate);

  if (formatId === -1) return licensePlate; // No valid format found

  let formatted;
  switch (formatId) {
    case 0:
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
      formatted = `${cleanedPlate.slice(0, 2)}-${cleanedPlate.slice(2, 4)}-${cleanedPlate.slice(4, 6)}`;
      break;
    case 6:
    case 8:
      formatted = `${cleanedPlate.slice(0, 2)}-${cleanedPlate.slice(2, 5)}-${cleanedPlate.slice(5)}`;
      break;
    case 7:
    case 9:
      formatted = `${cleanedPlate.slice(0, 1)}-${cleanedPlate.slice(1, 4)}-${cleanedPlate.slice(4)}`;
      break;
    case 10:
    case 13:
      formatted = `${cleanedPlate.slice(0, 3)}-${cleanedPlate.slice(3, 5)}-${cleanedPlate.slice(5)}`;
      break;
    case 11:
    case 12:
      formatted = `${cleanedPlate.slice(0, 1)}-${cleanedPlate.slice(1, 3)}-${cleanedPlate.slice(3)}`;
      break;
    default:
      formatted = licensePlate;
      break;
  }
  return formatted;
};

// Validation function
export const validateLicensePlate = (licensePlate: string): boolean => {
  // Basic character check first
  const allowedChars = /^[A-Z0-9-]*$/;
  if (!allowedChars.test(licensePlate)) {
    return false;
  }

  // Clean the license plate and check if it matches any of the defined patterns
  const cleanedPlate = licensePlate.replace(/-/g, "").toUpperCase();

  // Check if the cleaned plate matches any of the regex patterns
  return regexPatterns.some((pattern) => pattern.test(cleanedPlate));
};
